import { useContext } from 'react';
import { SignalRContext, SignalRContextType } from './signalRContextDef';

export const useSignalR = (): SignalRContextType => {
  const context = useContext(SignalRContext);
  if (!context) {
    throw new Error('useSignalR must be used within a SignalRProvider');
  }
  return context;
};
